import React from 'react'
import ContentLoader from 'react-content-loader'

const ImageViewerLoader = props => (
    <ContentLoader
    width={800}
    height={575}
    viewBox="0 0 800 575"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >            
    <rect x="55" y="42" rx="16" ry="16" width="274" height="216" />
    <rect x="350" y="42" rx="16" ry="16" width="90" height="65" />
    <rect x="450" y="42" rx="16" ry="16" width="90" height="65" />
    <rect x="550" y="42" rx="16" ry="16" width="90" height="65" />
    <rect x="350" y="115" rx="16" ry="16" width="90" height="65" />
    <rect x="350" y="190" rx="16" ry="16" width="90" height="65" />
    <rect x="350" y="42" rx="16" ry="16" width="90" height="65" />
    <rect x="450" y="115" rx="16" ry="16" width="90" height="65" />
    <rect x="450" y="190" rx="16" ry="16" width="90" height="65" />
    <rect x="450" y="115" rx="16" ry="16" width="90" height="65" />
    <rect x="550" y="115" rx="16" ry="16" width="90" height="65" />
    <rect x="550" y="190" rx="16" ry="16" width="90" height="65" />
    <rect x="550" y="115" rx="16" ry="16" width="90" height="65" />
  </ContentLoader>
)

export default ImageViewerLoader;